import {
  GET_TENANT,
  GET_TENANT_SUCCESS,
  GET_TENANT_ERROR,
  DELETE_TENANT,
  DELETE_TENANT_SUCCESS,
  DELETE_TENANT_ERROR,
} from "../actions";

const INIT_STATE = {
  tenantId: null,
  tenant: null,
  primaryContact: null,
  primaryOrganizationContact: null,
  tenantDetailsError: "",
  trashTenantSuccess: "",
  trashTenantError: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TENANT:
      return {
        ...state,
        loading: true,
        tenantId: action.payload.tenantName,
        tenantDetailsError: "",
      };
    case GET_TENANT_SUCCESS:
      return {
        ...state,
        loading: false,
        tenantDetailsError: "",
        tenant: action.payload.tenant,
        primaryContact: action.payload.primaryContact,
        primaryOrganizationContact: action.payload.primaryOrganizationContact,
      };
    case GET_TENANT_ERROR:
      return {
        ...state,
        loading: false,
        tenantDetailsError: action.payload ? action.payload.message : "",
      };
    case DELETE_TENANT:
      return {
        ...state,
        loading: true,
        tenantName: action.payload.tenantName,
        trashTenantError: "",
        trashTenantSuccess: "",
      };
    case DELETE_TENANT_SUCCESS:
      return {
        ...state,
        loading: false,
        trashTenantSuccess: action.payload ? action.payload.successMessage : "",
      };
    case DELETE_TENANT_ERROR:
      return {
        ...state,
        loading: false,
        trashTenantError: action.payload ? action.payload.message : "",
      };
    default:
      return { ...state };
  }
};
